import script from "./ProcedurePage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProcedurePage.vue?vue&type=script&setup=true&lang=ts"

import "./ProcedurePage.vue?vue&type=style&index=0&id=2114b0c1&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2114b0c1"]])

export default __exports__